App.controller('ResetPasswordCtrl', ResetPasswordCtrl);

ResetPasswordCtrl.$inject = [
    'DispatcherService',
    'DialogService'
];

function ResetPasswordCtrl(DispatcherService, DialogService) {
    var vm = this;

    vm.email = '';

    vm.submit = submit;

    function submit() {
        DispatcherService.post('password/reset', {email: vm.email}).then(function() {
            DialogService.success('Check your email inbox for a link to update your password');

            vm.email = '';
        });
    }
}